<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Symptoms",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Symptoms",
            items: [
               {
                  text: "Symptoms",
                  href: "/consultations",
               },                
               
               {
                  text: "Details",
                  active: true,
               },                     
            ],
            symptoms: {},

         };
      },
      mounted() {
      },
      created() {
         this.fetchSymptoms();
      },
      methods: {

         fetchSymptoms(page_url = null){

         this.getToken();
         let url = "clinic/doctor/symptoms?booking_id=" + this.$route.params.id;

         page_url = page_url || url;

         if(localStorage.back_url) {
            page_url = localStorage.back_url;  
            localStorage.removeItem('back_url');
         }    

         this.active_page_url = page_url;
         this.loading = true;

         this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               this.symptoms = responseData;
               console.log(responseData);
         })
         .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     if(typeof error.response.data.message === 'object') {
                        console.log(error.response.status);
                     } else {
                        this.$swal("", error.response.data.message, "error");
                     }                        
                     
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
         })
         .finally(() => (this.loading = false));



         },

         getToken() {
         if (localStorage.getItem('medicino_clinic')) {
            var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
            if(medicino_clinic.token) {
               this.token = medicino_clinic.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }
            
         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
         },
      },
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
                        
                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  <!---- listing table starts -------->
                  <div class="row">
                     <div >
                      
         <b-card header-class="bg-transparent border-light" class="border border-light">
            <h4 class="font-size-18 bg-light border border-top-0 border-start-0 border-end-0 p-3 mb-3">Symptoms Questions & Answers</h4>
               <div class="table-responsive">
                  <table class="table mb-0">
                     <tbody>  
                        <tr v-for="(symptom, index) in symptoms" :key="symptom.patient_syptom_id">
                           <td>
                                          <h5>{{index + 1}}. {{symptom.question}}</h5>
                                          <p v-if="!symptom.sub_question">
                                             <span v-if="symptom.answer === 1">Yes</span>
                                             <span v-if="symptom.answer === 2">No</span>
                                          </p>
                                          <table class="table mb-0">
                                             <tbody>                                   
                                                <tr>
                                                   <td v-if="symptom.sub_question">
                                                      <h6>a. {{symptom.sub_question}}</h6>
                                                         <p>
                                                            <span v-if="symptom.answer === 1">Yes</span>
                                                            <span v-if="symptom.answer === 2">No</span>
                                                         </p>
                                                   </td>
                                                </tr>
                                                
                                             </tbody>
                                          </table>
                                          
                                       </td>
                        </tr> 
                     </tbody>
                  </table>
               </div>
         </b-card>

                     </div>
                
                  </div>
                 
                  <!---- listing table ends -------->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
